import { useEffect, useState } from "react";
import card1 from "../Images/card1.png";
import card5 from "../Images/card5.jpg";
import roomzhub from "../Images/roomzhub.png";
import roomzhubv2 from "../Images/roomzhubv2.png";
import slate from "../Images/slate.png";
import { MdArrowOutward } from "react-icons/md";

const cards = [
  { id: 1, label: "Random App", img: card1 },
  { id: 2, label: "Roomshub webapp", img: roomzhub },
  { id: 3, label: "Slayt App", img: slate },
  { id: 4, label: "Roomshub webapp", img: roomzhubv2 },
  { id: 5, label: "Random App", img: card5 },
];

const animationTypes = ["flip-left", "flip-right", "fade-in"];

export const OurProject = () => {
  const [centerIndex, setCenterIndex] = useState(2);
  const [animationMap, setAnimationMap] = useState<string[]>([]);

  const getRandomAnimations = () =>
    cards.map(
      () => animationTypes[Math.floor(Math.random() * animationTypes.length)]
    );

  useEffect(() => {
    setAnimationMap(getRandomAnimations());

    const interval = setInterval(() => {
      setCenterIndex((prev) => {
        const nextIndex = (prev + 1) % cards.length;
        setAnimationMap(getRandomAnimations()); // update animations for each rotation
        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const rotateCards = () => {
    return cards.map((_, i) => cards[(centerIndex + i) % cards.length]);
  };

  const getHeightByIndex = (idx: number, total: number) => {
    const center = Math.floor(total / 2);
    const distance = Math.abs(idx - center);
    const baseHeight = 350;
    const step = 50;
    return baseHeight + step * (center - distance);
  };

  return (
    <div className="flex gap-4m items-center justify-center py-12 transition-all duration-500 ease-in-out overflow-x-auto w-fit">
      {rotateCards().map((card, idx) => {
        const height = getHeightByIndex(idx, cards.length);
        var animation = animationMap[idx] || "";

        if (idx === 2) {
          animation = "fade-in";
        }

        return (
          <div
            key={idx}
            className={`rounded-[30px] flex flex-col transition-all duration-500 cursor-pointer ${
              idx === Math.floor(cards.length / 2)
                ? "w-[90vw] md:w-[23vw]"
                : "w-[5vw] md:w-[15vw]"
            }`}
            style={{ height: `${height}px` }}
          >
            <img
              src={card.img}
              alt="slate"
              className={`w-full ${
                idx === Math.floor(cards.length / 2)
                  ? "h-[65%] rounded-t-[30px]"
                  : "h-full rounded-[30px]"
              } ${animation}`}
            />
            {idx === Math.floor(cards.length / 2) && (
              <div className="bg-[#09A7E4] rounded-b-[30px] h-[35%] w-full flex flex-col items-center justify-center">
                <div className="leading-[100%] tracking-[0%] font-medium text-[25px] text-white mb-5">
                  {card.label}
                </div>
                <div className="mx-auto bg-[#0FB8F9] size-[75px] rounded-[50%] flex items-center justify-center cursor-pointer">
                  <MdArrowOutward className="text-white text-[40px] border-[3px] rounded-[50%]" />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
